<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.destino"
        ref="RkmDataTable"
        sort-by="descricaoDestino"
    >

        <template v-slot:cell(numeroDocumento)="row">
            <template v-if="(row.item.documentoTipoId === enums.documentoTipo.CNPJ)">{{ row.value | formatCnpj }}</template>
            <template v-else-if="(row.item.documentoTipoId === enums.documentoTipo.CPF)">{{ row.value | formatCpf }}</template>
            <template v-else>-</template>
        </template>

        <template v-slot:cell(descricaoTipoDestino)="row">
            <template v-if="(row.item.descricaoTipoDestino)">{{ row.value }}</template>
            <template v-else>-</template>
        </template>

        <template v-slot:cell(actions)="{ item }">
            <template v-if="!$scopedSlots.actions">
                <rkm-button
                    @click="handleEdit(item.id)"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-destino"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    v-if="!item.bloqueado"
                    @click="handleBlock(item.id, false)"
                    color="dark"
                    small
                    title="Inativar"
                    autorize="update-transporte-paciente-destino"
                >
                    <rkm-icon icon="ban"/>
                </rkm-button>

                <rkm-button
                    v-else
                    @click="handleBlock(item.id, true)"
                    color="success"
                    small
                    title="Ativar"
                    autorize="update-transporte-paciente-destino"
                >
                    <rkm-icon icon="check-circle"/>
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    autorize="destroy-transporte-paciente-destino"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>

                <slot
                    name="actions"
                    :destino="item"
                />
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Enums.
import documentoTipo from '@/enums/cadastro/documentoTipo'

// Mixins.
import { error, repository, stringCase} from '@/mixins';

// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'descricaoDestino',
                    label: 'Nome',
                    name: 'transportePacienteDestino.descricaoDestino',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'numeroDocumento',
                    label: 'Documento (CNPJ/CPF)',
                    name: 'transportePacienteDestino.documentoTipoId',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'municipio',
                    label: 'Município',
                    name: 'municipio.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoTipoDestino',
                    label: 'Tipo',
                    name: 'transportePacienteDestinoTipo.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    name: 'transportePacienteDestino.bloqueado',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ];
        }
    },
    created() {
        this.repositories = {
            destino: this.getConectaSusRepository('transportePaciente.destino')
        }
    },
    data: () => ({
        enums: { documentoTipo },
    }),
    filters: {
        formatCnpj: formats.formatCnpj,
        formatCpf: formats.formatCpf,
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'transporte-paciente-destino-edit', params: { id: id } })
        },
        handleBlock(id, ativar) {

            const bloqueio = () => this.repositories.destino.bloquear(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showConfirmation(
                `Deseja realmente ${ativar ? 'ativar' : 'inativar'} o destino?`,
                bloqueio,
                null,
                this.handleError
            )
        },
        handleDestroy(id) {
            const exclusao = () => this.repositories.destino.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation(
                'Deseja realmente excluir o destino?',
                exclusao,
                this.handleError
            )
        },
    },
    mixins: [ error, repository, stringCase ],
};

</script>